import gql from 'graphql-tag';

export default gql`
  mutation deleteCourseLearningNote($id: String!) {
    # 删除
    deleteCourseLearningNote(id: $id) {
      id
    }
  }
`;
